import { render, staticRenderFns } from "./formTemplateSetup.vue?vue&type=template&id=4c42c9a2&scoped=true&"
import script from "./formTemplateSetup.vue?vue&type=script&lang=js&"
export * from "./formTemplateSetup.vue?vue&type=script&lang=js&"
import style0 from "./formTemplateSetup.vue?vue&type=style&index=0&id=4c42c9a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c42c9a2",
  null
  
)

export default component.exports